export default __webpack_public_path__ + "static/media/img_declaration_slogan3.28dfccd9.png";